import { app } from '../../../app';

app.factory('DomainsService', DomainsService);

/** @ngInject */
function DomainsService($resource) {
    return $resource('app/rest/:companyId/domains/:id', {companyId : '@companyId', id:"@id"}, {});
}



// WEBPACK FOOTER //
// ./src/portal/states/company/domains/domains.service.js